var _defs, _rect, _text, _text2, _text3, _circle, _g, _path, _circle2, _g2, _text4, _text5, _text6, _rect2, _line, _g3, _path2, _path3, _path4, _path5, _rect3, _text7, _text8, _text9, _rect4, _text10, _text11, _text12, _line2, _line3, _text13;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCase04TreeFaceSampling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 760,
    viewBox: "0 0 1600 760",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f8faf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf7ef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stem",
    x1: 0,
    x2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35794a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58a36d"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowGold",
    markerWidth: 10,
    markerHeight: 10,
    refX: 8,
    refY: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#d5a21c"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowBlue",
    markerWidth: 10,
    markerHeight: 10,
    refX: 8,
    refY: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#347fb1"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrowGreen",
    markerWidth: 10,
    markerHeight: 10,
    refX: 8,
    refY: 5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#328655"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 760,
    rx: 34,
    fill: "url(#bg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 72,
    fontFamily: "sans-serif",
    fontSize: 20,
    fontWeight: 800,
    letterSpacing: 3,
    fill: "#367a50"
  }, "TREE-FACE SAMPLING")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 130,
    fontFamily: "sans-serif",
    fontSize: 42,
    fontWeight: 800,
    fill: "#17251d"
  }, "\u30CF\u30A6\u30B9\u5185\u306E\u30A8\u30EA\u30A2\u3067\u306F\u306A\u304F\u3001\u5404\u6A39\u306E\u53D7\u5149\u9762\u3092\u8FFD\u3063\u3066\u6E2C\u5B9A\u3002")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 174,
    fontFamily: "sans-serif",
    fontSize: 22,
    fill: "#68766e"
  }, "12\u6642\u524D\u306F\u6A39\u306E\u6771\u9762\u300112\u6642\u904E\u304E\u306F\u6A39\u306E\u897F\u9762\u3002\u592A\u967D\u306E\u79FB\u52D5\u306B\u5408\u308F\u305B\u3066\u3001\u5149\u304C\u5F53\u305F\u308B\u8449\u3092\u9078\u3073\u307E\u3057\u305F\u3002")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265,
    cy: 275,
    r: 44,
    fill: "#f6c843"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#f6c843",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 265,
    y1: 205,
    x2: 265,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    x1: 265,
    y1: 345,
    x2: 265,
    y2: 370
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 275,
    x2: 170,
    y2: 275
  }), /*#__PURE__*/React.createElement("line", {
    x1: 335,
    y1: 275,
    x2: 360,
    y2: 275
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215,
    y1: 225,
    x2: 196,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315,
    y1: 225,
    x2: 334,
    y2: 206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215,
    y1: 325,
    x2: 196,
    y2: 344
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315,
    y1: 325,
    x2: 334,
    y2: 344
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330 265 C650 105, 950 105, 1265 265",
    fill: "none",
    stroke: "#d5a21c",
    strokeWidth: 7,
    strokeDasharray: "14 12",
    markerEnd: "url(#arrowGold)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1335,
    cy: 275,
    r: 44,
    fill: "#f2b53c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f2b53c",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1335,
    y1: 205,
    x2: 1335,
    y2: 180
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1335,
    y1: 345,
    x2: 1335,
    y2: 370
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1265,
    y1: 275,
    x2: 1240,
    y2: 275
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1405,
    y1: 275,
    x2: 1430,
    y2: 275
  }))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 398,
    fontFamily: "sans-serif",
    fontSize: 22,
    fontWeight: 800,
    fill: "#2f7fae"
  }, "\u5348\u524D")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 1298,
    y: 398,
    fontFamily: "sans-serif",
    fontSize: 22,
    fontWeight: 800,
    fill: "#2f8553"
  }, "\u5348\u5F8C")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 756,
    y: 228,
    fontFamily: "sans-serif",
    fontSize: 18,
    fontWeight: 800,
    fill: "#8a7426"
  }, "12:00 \u5207\u66FF")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 540,
    y: 220,
    width: 520,
    height: 455,
    rx: 34,
    fill: "#fff",
    stroke: "#d9e5dc",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 800,
    y1: 300,
    x2: 800,
    y2: 620,
    stroke: "url(#stem)",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#6eb080",
    stroke: "#3d8255",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 690,
    cy: 350,
    rx: 95,
    ry: 34,
    transform: "rotate(-22 690 350)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 705,
    cy: 450,
    rx: 105,
    ry: 37,
    transform: "rotate(-18 705 450)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 690,
    cy: 550,
    rx: 92,
    ry: 34,
    transform: "rotate(-20 690 550)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 910,
    cy: 390,
    rx: 96,
    ry: 34,
    transform: "rotate(22 910 390)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 900,
    cy: 495,
    rx: 108,
    ry: 38,
    transform: "rotate(18 900 495)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 910,
    cy: 585,
    rx: 90,
    ry: 32,
    transform: "rotate(20 910 585)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M610 320 C650 300, 720 300, 780 330",
    fill: "none",
    stroke: "#347fb1",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M820 330 C900 300, 970 320, 1010 350",
    fill: "none",
    stroke: "#328655",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M610 440 C660 410, 730 415, 785 445",
    fill: "none",
    stroke: "#347fb1",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M815 455 C875 425, 960 430, 1010 465",
    fill: "none",
    stroke: "#328655",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85,
    y: 465,
    width: 390,
    height: 190,
    rx: 24,
    fill: "#fff",
    stroke: "#cfe1ec",
    strokeWidth: 3
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 512,
    fontFamily: "sans-serif",
    fontSize: 16,
    fontWeight: 800,
    letterSpacing: 2,
    fill: "#347fb1"
  }, "BEFORE NOON")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 560,
    fontFamily: "sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#18344a"
  }, "\u6A39\u306E\u6771\u9762")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 600,
    fontFamily: "sans-serif",
    fontSize: 20,
    fill: "#62727a"
  }, "\u5149\u304C\u5F53\u305F\u3063\u3066\u3044\u308B\u8449\u3092\u6E2C\u5B9A")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1125,
    y: 465,
    width: 390,
    height: 190,
    rx: 24,
    fill: "#fff",
    stroke: "#cfe4d5",
    strokeWidth: 3
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 512,
    fontFamily: "sans-serif",
    fontSize: 16,
    fontWeight: 800,
    letterSpacing: 2,
    fill: "#328655"
  }, "AFTER NOON")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 560,
    fontFamily: "sans-serif",
    fontSize: 34,
    fontWeight: 800,
    fill: "#173e27"
  }, "\u6A39\u306E\u897F\u9762")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1160,
    y: 600,
    fontFamily: "sans-serif",
    fontSize: 20,
    fill: "#62746a"
  }, "\u5149\u304C\u5F53\u305F\u3063\u3066\u3044\u308B\u8449\u3092\u6E2C\u5B9A")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 475,
    y1: 555,
    x2: 610,
    y2: 500,
    stroke: "#347fb1",
    strokeWidth: 5,
    markerEnd: "url(#arrowBlue)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1125,
    y1: 555,
    x2: 990,
    y2: 505,
    stroke: "#328655",
    strokeWidth: 5,
    markerEnd: "url(#arrowGreen)"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 800,
    y: 718,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 19,
    fill: "#6b7770"
  }, "\u540C\u3058\u30CF\u30A6\u30B9\u5185\u3067\u3001\u6A39\u3054\u3068\u306E\u6771\u897F\u306E\u300C\u9762\u300D\u3092\u5207\u308A\u66FF\u3048\u3066\u6E2C\u5B9A\u3002\u6771\u897F\u306E\u30A8\u30EA\u30A2\u6BD4\u8F03\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase04TreeFaceSampling);
export default __webpack_public_path__ + "static/media/case04-tree-face-sampling.a0ccdefa5f78de67b99b9fe85bc3c286.svg";
export { ForwardRef as ReactComponent };